import clsx from "clsx";
import React from "react";

import SvgIcon, { classes } from "./SvgIcon";
import { SvgIconProps } from "./types";

type Direction = "up" | "down" | "left" | "right";

// Classes littérales (et non `rotate-${deg}`) pour rester visibles du scanner v4
const DIRECTIONS: {
    [key in Direction]: string;
} = {
    up: "rotate-0",
    right: "rotate-90",
    down: "rotate-180",
    left: "rotate-270",
};

type Props = { direction?: Direction } & SvgIconProps;

const Chevron = ({ className, direction = "down", ...props }: Props) => {
    const { stroke } = classes;

    const rotateDirection = DIRECTIONS[direction];

    return (
        <SvgIcon {...props} className={clsx("transition-transform", rotateDirection, className)}>
            <path
                d="M18 14L12 8L6 14"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={stroke}
            />
        </SvgIcon>
    );
};

export default Chevron;
